/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import { type CTAStyling, CTAStylingSchema } from '../shared/cta-styling'
import type { Equal, ExpectTrue } from '../types/validation'

import { type ContentLink, ContentLinkSchema } from './content-link'
import { type CmsIcon, CmsIconSchema } from './icon'

/* TypeScript */
export type RelatedLink = {
  label: string
  icon?: Maybe<CmsIcon>
  link: ContentLink
  mood: CTAStyling
}

/* Schemas */
export const RelatedLinkSchema = z.object({
  label: z.string(),
  icon: z.nullish(CmsIconSchema),
  link: ContentLinkSchema,
  mood: CTAStylingSchema,
})

/* Schemas validation */
type TestRelatedLink = ExpectTrue<
  Equal<RelatedLink, z.infer<typeof RelatedLinkSchema>>
>
